import _ from "lodash";

import { FamilyState } from "@reducers/types/HRM/family-state";

import { FamilyActions } from "@actions/HRM/employee/family-actions";
import {
  GET_EMPLOYEE_FAMILY,
  UPDATE_PARENT_INFO,
  UPDATE_SPOUSE_INFO,
  UPDATE_CHILDREN_INFO,
  UPDATE_EMERGENCY_CONTACT_INFO,
  UPDATE_PERMANENT_ADDRESS_INFO,
  UPDATE_PRESENT_ADDRESS_INFO,
  DELETE_CHILD_INFO,
  DELETE_SPOUSE_INFO,
} from "@actions/HRM/employee/types";

import {
  getInitialState,
  getRequestingState,
  getSuccessState,
  getFailedState,
} from "@utils/store";

const initialState: FamilyState = { ...getInitialState() };

const resetStates = {
  updateParentSuccess: false,
  updateParentFailed: false,
  updateSpouseSuccess: false,
  updateSpouseFailed: false,
  updateChildSuccess: false,
  updateChildFailed: false,
  updateEmergencyContactSuccess: false,
  updateEmergencyContactFailed: false,
  updatePermanentAddressSuccess: false,
  updatePermanentAddressFailed: false,
  updatePresentAddressSuccess: false,
  updatePresentAddressFailed: false,
  deleteChildSuccess: false,
  deleteChildFailed: false,
  deleteSpouseSuccess: false,
  deleteSpouseFailed: false,
};

const familyInfoReducer = (
  state = initialState,
  action: FamilyActions,
): FamilyState => {
  switch (action.type) {
    case GET_EMPLOYEE_FAMILY.GET_FAMILY_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          getFamilyInfoRequestOngoing: true,
          getFamilyInfoSuccess: false,
          getFamilyInfoFailed: false,
        }),
      };

    case GET_EMPLOYEE_FAMILY.GET_FAMILY_SUCCESS: {
      const { payload } = action as any;
      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: payload.data,
          getFamilyInfoRequestOngoing: false,
          getFamilyInfoSuccess: true,
          getFamilyInfoFailed: false,
        }),
      };
    }

    case GET_EMPLOYEE_FAMILY.GET_FAMILY_FAILED:
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          getFamilyInfoRequestOngoing: false,
          getFamilyInfoSuccess: false,
          getFamilyInfoFailed: true,
        }),
      };

    case UPDATE_PARENT_INFO.UPDATE_PARENT_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateParentRequestOngoing: true,
          updateParentSuccess: false,
          updateParentFailed: false,
        }),
      };

    case UPDATE_PARENT_INFO.UPDATE_PARENT_INFO_SUCCESS: {
      const { payload } = action as any;

      const currentData = _.cloneDeep(state.data);
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["parents"] = payload.data;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateParentRequestOngoing: false,
          updateParentSuccess: true,
          updateParentFailed: false,
        }),
      };
    }

    case UPDATE_PARENT_INFO.UPDATE_PARENT_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updateParentRequestOngoing: false,
          updateParentSuccess: false,
          updateParentFailed: true,
        }),
      };
    }

    case UPDATE_SPOUSE_INFO.UPDATE_SPOUSE_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateSpouseRequestOngoing: true,
          updateSpouseSuccess: false,
          updateSpouseFailed: false,
        }),
      };

    case UPDATE_SPOUSE_INFO.UPDATE_SPOUSE_INFO_SUCCESS: {
      // const { payload } = action as any;

      // const currentData = _.cloneDeep(state.data);
      // const updatedData = currentData || ({} as { [key: string]: any });
      // updatedData["spouse"] = payload.data;

      const { payload } = action as any;
      const currentSpouse =
        state && state.data && state.data.spouse ? state.data.spouse : [];

      let updatedSpouse = currentSpouse;
      const indexOfNewSpouse = currentSpouse.findIndex(
        (spouse: any) => spouse.id === payload.data.id,
      );
      if (indexOfNewSpouse === -1) updatedSpouse.push(payload.data);
      else updatedSpouse[indexOfNewSpouse] = payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["spouse"] = updatedSpouse;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateSpouseRequestOngoing: false,
          updateSpouseSuccess: true,
          updateSpouseFailed: false,
        }),
      };
    }

    case UPDATE_SPOUSE_INFO.UPDATE_SPOUSE_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updateSpouseRequestOngoing: false,
          updateSpouseSuccess: false,
          updateSpouseFailed: true,
        }),
      };
    }

    case UPDATE_CHILDREN_INFO.UPDATE_CHILDREN_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateChildRequestOngoing: true,
          updateChildSuccess: false,
          updateChildFailed: false,
        }),
      };

    case UPDATE_CHILDREN_INFO.UPDATE_CHILDREN_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentChildren =
        state && state.data && state.data.children ? state.data.children : [];

      let updatedChildren = currentChildren;
      const indexOfNewChild = currentChildren.findIndex(
        (child: any) => child.id === payload.data.id,
      );
      if (indexOfNewChild === -1) updatedChildren.push(payload.data);
      else updatedChildren[indexOfNewChild] = payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["children"] = updatedChildren;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateChildRequestOngoing: false,
          updateChildSuccess: true,
          updateChildFailed: false,
        }),
      };
    }

    case UPDATE_CHILDREN_INFO.UPDATE_CHILDREN_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updateChildRequestOngoing: false,
          updateChildSuccess: false,
          updateChildFailed: true,
        }),
      };
    }

    case UPDATE_EMERGENCY_CONTACT_INFO.UPDATE_EMERGENCY_CONTACT_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state.data,
          updateEmergencyContactRequestOngoing: true,
          updateEmergencyContactSuccess: false,
          updateEmergencyContactFailed: false,
        }),
      };

    case UPDATE_EMERGENCY_CONTACT_INFO.UPDATE_EMERGENCY_CONTACT_INFO_SUCCESS: {
      const { payload } = action as any;
      return {
        ...getSuccessState({
          data: {
            ...state.data,
            spouse: payload.data,
          },
          updateEmergencyContactRequestOngoing: false,
          updateEmergencyContactSuccess: true,
          updateEmergencyContactFailed: false,
        }),
      };
    }

    case UPDATE_EMERGENCY_CONTACT_INFO.UPDATE_EMERGENCY_CONTACT_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state.data,
          updateEmergencyContactRequestOngoing: false,
          updateEmergencyContactSuccess: false,
          updateEmergencyContactFailed: true,
        }),
      };
    }

    case UPDATE_PERMANENT_ADDRESS_INFO.UPDATE_PERMANENT_ADDRESS_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updatePermanentAddressRequestOngoing: true,
          updatePermanentAddressSuccess: false,
          updatePermanentAddressFailed: false,
        }),
      };

    case UPDATE_PERMANENT_ADDRESS_INFO.UPDATE_PERMANENT_ADDRESS_INFO_SUCCESS: {
      const { payload } = action as any;

      const currentData = _.cloneDeep(state.data);
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["employeePermanentAddresses"] = payload.data;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updatePermanentAddressRequestOngoing: false,
          updatePermanentAddressSuccess: true,
          updatePermanentAddressFailed: false,
        }),
      };
    }

    case UPDATE_PERMANENT_ADDRESS_INFO.UPDATE_PERMANENT_ADDRESS_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updatePermanentAddressRequestOngoing: false,
          updatePermanentAddressSuccess: false,
          updatePermanentAddressFailed: true,
        }),
      };
    }

    case UPDATE_PRESENT_ADDRESS_INFO.UPDATE_PRESENT_ADDRESS_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updatePresentAddressRequestOngoing: true,
          updatePresentAddressSuccess: false,
          updatePresentAddressFailed: false,
        }),
      };

    case UPDATE_PRESENT_ADDRESS_INFO.UPDATE_PRESENT_ADDRESS_INFO_SUCCESS: {
      const { payload } = action as any;

      const currentData = _.cloneDeep(state.data);
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["employeePresentAddresses"] = payload.data;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updatePresentAddressRequestOngoing: false,
          updatePresentAddressSuccess: true,
          updatePresentAddressFailed: false,
        }),
      };
    }

    case UPDATE_PRESENT_ADDRESS_INFO.UPDATE_PRESENT_ADDRESS_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updatePresentAddressRequestOngoing: false,
          updatePresentAddressSuccess: false,
          updatePresentAddressFailed: true,
        }),
      };
    }

    case DELETE_CHILD_INFO.DELETE_CHILD_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteChildRequestOngoing: true,
          deleteChildSuccess: false,
          deleteChildFailed: false,
        }),
      };

    case DELETE_CHILD_INFO.DELETE_CHILD_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedChildrenInfo =
        state && state.data && state.data.children
          ? state.data.children.filter(
              (child: any) => child.id !== payload.data.id,
            )
          : [];

      const currentData = _.cloneDeep(state.data);
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["children"] = updatedChildrenInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteChildRequestOngoing: false,
          deleteChildSuccess: true,
          deleteChildFailed: false,
        }),
      };
    }

    case DELETE_CHILD_INFO.DELETE_CHILD_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deleteChildRequestOngoing: false,
          deleteChildSuccess: false,
          deleteChildFailed: true,
        }),
      };
    }

    case DELETE_SPOUSE_INFO.DELETE_SPOUSE_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteSpouseRequestOngoing: true,
          deleteSpouseSuccess: false,
          deleteSpouseFailed: false,
        }),
      };

    case DELETE_SPOUSE_INFO.DELETE_SPOUSE_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedSpouseInfo =
        state && state.data && state.data.spouse
          ? state.data.spouse.filter(
              (spouse: any) => spouse.id !== payload.data.id,
            )
          : [];

      const currentData = _.cloneDeep(state.data);
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["spouse"] = updatedSpouseInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteSpouseRequestOngoing: false,
          deleteSpouseSuccess: true,
          deleteSpouseFailed: false,
        }),
      };
    }

    case DELETE_SPOUSE_INFO.DELETE_SPOUSE_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deleteSpouseRequestOngoing: false,
          deleteSpouseSuccess: false,
          deleteSpouseFailed: true,
        }),
      };
    }

    default:
      return state;
  }
};

export default familyInfoReducer;
